import { when } from "util/support";
import type { ReviewableInput } from "ui/widgets/Input";
import type { ReviewableFormInputProps } from "../types";
import useFieldsComments from "./useFieldsComments";
import { FieldStatus, useConfigContext } from "../providers";

export const useFieldsStatuses = ({
    setFieldValue,
    setFieldTouched,
    values,
    name
}: Pick<
    ReviewableFormInputProps,
    | 'setFieldValue'
    | 'setFieldTouched'
    | 'values'
    | 'name'
>) => {
    const config = useConfigContext();

    const { onApplyFieldReason } = useFieldsComments({
        setFieldValue,
        setFieldTouched,
        values,
        name
    });

    const changeFieldStatus = (status: FieldStatus) => {
        setFieldValue(
            config.FieldsStatuses,
            {
                ...values[config.FieldsStatuses],
                [name]: status
            }
        );

        setTimeout(() => setFieldTouched(config.FieldsStatuses, true, true));
    };

    const onReject: ReviewableInput.ReviewableInputProps['onReject'] = reason => {
        changeFieldStatus(config.FieldStatusRejected);
        when(reason?.notes, () => onApplyFieldReason(reason!));
    };

    const onApprove = () => changeFieldStatus(config.FieldStatusApproved);

    return {
        changeFieldStatus,
        onReject,
        onApprove
    };
};

export default useFieldsStatuses;
